import { render, staticRenderFns } from "./selectEvent.vue?vue&type=template&id=b50e3754&scoped=true&"
import script from "./selectEvent.vue?vue&type=script&lang=js&"
export * from "./selectEvent.vue?vue&type=script&lang=js&"
import style0 from "./selectEvent.vue?vue&type=style&index=0&id=b50e3754&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50e3754",
  null
  
)

export default component.exports